import { USER_LOGIN, USER_LOGOUT, USER_UPDATE } from "./actionTypes";

const initialState = {
  isLoggedIn: false,
  user: null,
};

const userInfo = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN:
      state = {
        ...state,
        isLoggedIn: true,
        user: action.payload,
      };
      break;
    case USER_UPDATE:
      state = {
        ...state,
        user: action.payload,
      };
      break;
    case USER_LOGOUT:
      state = {
        ...state,
        isLoggedIn: false,
        user: null,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default userInfo;
